import YViewConfigManager from "../../components/pages/DynamicConfig";

const Config = () => {
  return (
    <YViewConfigManager/>
  );
};

export default Config;